<div class="ub ub-ver dialog-div" :style="{width:dialogWidth>0?dialogWidth+'px':'90%'}">
  <div v-if="hasHeaderSlot" class="dialog-div__hd" :style="{'min-height':dialogHeaderHeight+'px'}">
    <slot name="header"></slot>
  </div>
  <div v-if="!hasHeaderSlot && title" class="ub fw dialog-div__hd" :style="{'min-height':dialogHeaderHeight+'px'}">
    <div class="ub ub-pb ub-ac fw">
      <div class="ub ub-ae">
        <span class="ub ub-ac title">{{title}}</span>
        <small class="ub ub-ac sub-title">{{subTitle}}</small>
      </div>
    </div>
  </div>
<close-outlined @click="close" :style="{fontSize:'16px',cursor:'pointer'}" style="position:absolute; right: 24px;top:17px;z-index: 999"/>

  <div v-if="hasBodySlot" class="dialog-div__bd" :style="{'max-height':dialogBodyHeight+'px'}">
    <slot name="body"></slot>
  </div>
  <div v-else class="dialog-div__bd" :style="{'max-height':dialogBodyHeight+'px'}">
    <slot></slot>
  </div>

  <template v-if="showFooter">
    <div v-if="hasFooterSlot" class="dialog-div__ft" :style="{height:dialogFooterHeight+'px'}">
      <slot name="footer"></slot>
    </div>
    <div v-else class="ub ub-pe fw dialog-div__ft" :style="{height:dialogFooterHeight+'px'}">
      <a-space>
        <a-button @click="close">{{cancelText}}</a-button>
        <a-button type="primary" @click="ok" :loading="loading">{{confirmText}}</a-button>
      </a-space>
    </div>
  </template>
</div>
